import gsap from 'gsap';
import { PL_COLOR_BG } from './atoms';

export const RECOVERY_CAROUSEL_THEME_TRIGGER_SELECTOR =
  '[data-recovery-carousel-trigger]';

export const RECOVERY_THEME_VAR_BG = '--recovery-theme-bg';
export const RECOVERY_THEME_VAR_TEXT = '--recovery-theme-text';
export const RECOVERY_THEME_VAR_MUTED = '--recovery-theme-muted';
export const RECOVERY_THEME_VAR_DIVIDER = '--recovery-theme-divider';
export const RECOVERY_THEME_VAR_HOVER = '--recovery-theme-hover';

const RECOVERY_THEME_DARK = {
  bg: '#000000',
  text: '#ffffff',
  muted: 'rgba(255, 255, 255, 0.7)',
  divider: 'rgba(255, 255, 255, 0.12)',
  hover: 'rgba(255, 255, 255, 0.03)',
} as const;

const RECOVERY_THEME_LIGHT = {
  bg: PL_COLOR_BG,
  text: '#000000',
  muted: 'rgba(0, 0, 0, 0.7)',
  divider: 'rgba(0, 0, 0, 0.12)',
  hover: 'rgba(0, 0, 0, 0.03)',
} as const;

export function applyRecoveryThemeProgress(
  element: HTMLElement,
  progress: number,
): void {
  const t = gsap.utils.clamp(0, 1, progress);

  element.style.setProperty(
    RECOVERY_THEME_VAR_BG,
    gsap.utils.interpolate(RECOVERY_THEME_DARK.bg, RECOVERY_THEME_LIGHT.bg, t),
  );
  element.style.setProperty(
    RECOVERY_THEME_VAR_TEXT,
    gsap.utils.interpolate(
      RECOVERY_THEME_DARK.text,
      RECOVERY_THEME_LIGHT.text,
      t,
    ),
  );
  element.style.setProperty(
    RECOVERY_THEME_VAR_MUTED,
    gsap.utils.interpolate(
      RECOVERY_THEME_DARK.muted,
      RECOVERY_THEME_LIGHT.muted,
      t,
    ),
  );
  element.style.setProperty(
    RECOVERY_THEME_VAR_DIVIDER,
    gsap.utils.interpolate(
      RECOVERY_THEME_DARK.divider,
      RECOVERY_THEME_LIGHT.divider,
      t,
    ),
  );
  element.style.setProperty(
    RECOVERY_THEME_VAR_HOVER,
    gsap.utils.interpolate(
      RECOVERY_THEME_DARK.hover,
      RECOVERY_THEME_LIGHT.hover,
      t,
    ),
  );
}

export function setRecoveryThemeLight(element: HTMLElement): void {
  applyRecoveryThemeProgress(element, 1);
}

export function setRecoveryThemeDark(element: HTMLElement): void {
  applyRecoveryThemeProgress(element, 0);
}
